import { SimulationConfig } from '@/domaine/SimulationConfig'

export const configLocationDeMeublé: SimulationConfig = {
	objectifs: ['location de logement meublé . cotisations'],
	'unité par défaut': '€/an',
	situation: {},
}
